module.exports = __webpack_public_path__ + "img/cake_dessert.be5030ca.webp";